import React, { useState } from 'react';

import { Button, Typography, Card, notification, Popover, Spin, Alert } from 'antd';

const { Title } = Typography;

import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';

import FileStore from 'stores/FileStore';

import { ErrorRender } from '@partsbadger/library';

import UserStore from 'stores/UserStore';

import { observer } from 'mobx-react';

interface IProps {
    removeUpload: () => void;
}

const DisplayUploadFile: React.FC<IProps> = ({ removeUpload }) => {
    const [loading, setLoading] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [sentFile, setSentFile] = useState(false);
    const fileName = FileStore.fileUploaded?.name?.split('.').shift() ?? '';

    const handleFileCreation = async () => {
        setLoading(true);
        await FileStore.sendFileCreation()
            .then(() => {
                setSentFile(true), setLoading(false);
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: <ErrorRender error={err} />,
                });
                setLoading(false);
            });
    };

    const handleDelete = () => {
        setConfirmDelete(false);
        removeUpload();
        FileStore.cleanStore();
    };

    const repName = UserStore.user?.default_contact?.account_owner.fullname;

    return (
        <div>
            <>
                {!sentFile ? (
                    <Card bordered={true} bodyStyle={{ padding: '1rem' }} className="shadow-sm">
                        <Spin spinning={loading} tip={'Sending...'} indicator={<LoadingOutlined />}>
                            <div className="flex flex-row justify-between items-center">
                                <Title level={4}>{fileName.toUpperCase()}</Title>
                                <span className={'link'}>
                                    <Popover
                                        content={
                                            <div className="flex justify-between">
                                                <a onClick={() => setConfirmDelete(false)}>Close</a>
                                                <a
                                                    className="text-red-600"
                                                    onClick={() => {
                                                        handleDelete();
                                                    }}
                                                >
                                                    Delete
                                                </a>
                                            </div>
                                        }
                                        title="Delete Upload?"
                                        trigger="click"
                                        open={confirmDelete}
                                        onOpenChange={setConfirmDelete}
                                    >
                                        <Button
                                            type="link"
                                            icon={<CloseOutlined />}
                                            // onClick={() => setConfirmDeleteModalVisible(true)}
                                        />
                                    </Popover>
                                </span>
                            </div>
                            <div className="flex justify-between items-center mt-5 mb-2">
                                <span>Ready to Send</span>

                                <span>
                                    <strong>Format to create:</strong>{' '}
                                    {FileStore?.fileType === '3D' ? '2D File' : '3D File'}
                                </span>

                                <span>
                                    <strong>Sales Rep:</strong> {repName}
                                </span>

                                <Button
                                    type="primary"
                                    onClick={() => {
                                        handleFileCreation();
                                    }}
                                >
                                    Send To Sales Rep
                                </Button>
                            </div>
                        </Spin>
                    </Card>
                ) : (
                    <div className="flex flex-col">
                        <Alert
                            type="success"
                            showIcon={true}
                            message="File Sent Successfully"
                            description={
                                <div>
                                    <span>
                                        The Document has been sent to your Sales Representative via email with the file
                                        attachment. Your Sales Representative will contact you regarding your request as
                                        soon as possible.
                                    </span>
                                </div>
                            }
                            className="mt-3 mb-3 align-center"
                        />
                        <div className="flex justify-center">
                            <Button
                                type="primary"
                                onClick={() => {
                                    handleDelete();
                                }}
                            >
                                New File Creation Request
                            </Button>
                        </div>
                    </div>
                )}
            </>
        </div>
    );
};

export default observer(DisplayUploadFile);
